import React, { useContext, useState } from "react";
import { FaFileUpload } from "react-icons/fa";
import { LucideBarcode } from "lucide-react";
import qrCodeImage from "../../images/QR_Code.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { MyContext } from "../../context/MyContext";
import { RxCross2 } from "react-icons/rx";

const PaymentGateway = ({ close }) => {
  const { API_BASE_URL, setShowPayment } = useContext(MyContext);
  const userId = localStorage.getItem("userId");
  const [transactionId, setTransactionId] = useState("");
  const [screenshot, setScreenshot] = useState(null);
  const navigate = useNavigate();
  const handleFileChange = (event) => {
    setScreenshot(event.target.files[0]);
  };

  const handleClose = () => {
    close();
    setShowPayment(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!transactionId || !screenshot) {
      alert(
        "Please enter a transaction ID and upload a screenshot before submitting."
      );
      return;
    }

    const formData = new FormData();
    formData.append("price", 500);
    formData.append("transitionId", transactionId);
    const currentDate = new Date().toLocaleDateString("en-GB");
    formData.append("dateTransaction", currentDate);

    if (screenshot) {
      formData.append("transaction_image", screenshot);
    }

    formData.forEach((val)=>{
      console.log(val);
      
    })
    axios
      .post(`https://api.ourmicrolife.com/api/user/mlmMembers/${userId}`, formData )
      .then((response) => {
        console.log(response);
        console.log("hello is working");
        alert("Transaction details submitted successfully!");
        setTransactionId("");
        setScreenshot(null);
        close();
        navigate("/welcome_congratulations");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while submitting transaction details!");
      });
  };

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-900 bg-opacity-50 px-4 sm:px-0 z-[1000] pt-40">
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-2xl w-full max-w-3xl border border-gray-300 flex flex-col sm:flex-row">
        {/* Left Side */}
        <div className="w-full sm:w-1/2 p-6 flex flex-col items-center bg-gray-100 rounded-t-lg sm:rounded-l-lg sm:rounded-tr-none">
          <img
            src="https://cdni.iconscout.com/illustration/premium/thumb/payment-gateway-illustration-download-in-svg-png-gif-file-formats--bitcoin-logo-crypto-bank-method-cryptocurrency-and-blockchain-pack-science-technology-illustrations-3710638.png?f=webp"
            alt="Transaction Info"
            className="mb-4 w-full h-40 sm:h-60 object-cover"
          />
          <p className="text-center text-gray-700 mb-4 font-semibold">
            Please enter your transaction details below.
          </p>

          {/* Transaction Input */}
          <div className="relative w-full">
            <LucideBarcode className="absolute left-3 top-4 text-blue-600 text-xl" />
            <input
              type="text"
              placeholder="Enter Transaction ID"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              className="border border-gray-300 p-3 pl-12 rounded-lg w-full shadow-md bg-white/50 backdrop-blur-lg text-gray-800 
                            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ease-in-out"
            />
          </div>

          {/* File Upload */}
          <label className="w-full flex items-center justify-center border border-gray-300 p-3 rounded-lg cursor-pointer shadow-md bg-white hover:bg-gray-200 transition-all duration-200 ease-in-out mt-4">
            <FaFileUpload className="mr-2 text-blue-600" />
            <span className="text-gray-600">
              {screenshot ? screenshot.name : "Upload Screenshot"}
            </span>
            <input type="file" onChange={handleFileChange} className="hidden" />
          </label>
        </div>

        {/* Right Side */}
        <div className="relative w-full sm:w-1/2 p-6 flex flex-col items-center justify-between bg-gray-50 rounded-b-lg sm:rounded-r-lg sm:rounded-bl-none">
          <div
            onClick={handleClose}
            className="absolute -right-5 -top-3 bg-indigo-600 p-2 rounded-[10px] text-white text-lg"
          >
            <RxCross2 />
          </div>
          <img
            src={qrCodeImage}
            alt="QR Code"
            className="mb-4 w-40 sm:w-full h-40 sm:h-80 object-cover"
          />

          <button
            onClick={handleSubmit}
            className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-6 py-3 rounded-lg hover:from-blue-600 hover:to-blue-800 shadow-md transform transition-transform hover:scale-105 self-center w-full sm:w-auto"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentGateway;
